module.exports = ".col-width{\r\n  width:35%!important;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Reports/rpt-search-history/rpt-search-history.component.css
// module id = ./src/app/Reports/rpt-search-history/rpt-search-history.component.css
// module chunks = main